/**
 * Lightweight client-side form validators. These mirror (but do not replace)
 * the server-side Zod validation; they exist to give users fast, friendly
 * feedback. Messages are in Vietnamese. Each validator returns either an error
 * message string or `null` when the value is valid.
 */

/** Basic RFC-ish email shape check (server does the authoritative validation). */
export function validateEmail(s: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s.trim());
}

/**
 * Validate a password. Returns an error message when invalid, otherwise null.
 * Rule: at least 8 characters (matches the server registration policy).
 */
export function validatePassword(s: string): string | null {
  if (!s) return 'Vui lòng nhập mật khẩu';
  if (s.length < 8) return 'Mật khẩu phải có ít nhất 8 ký tự';
  return null;
}

/**
 * Assert a value is present (non-empty). Returns an error message when the
 * value is missing/blank, otherwise null.
 */
export function required(v: unknown): string | null {
  if (v === null || v === undefined) return 'Trường này là bắt buộc';
  if (typeof v === 'string' && v.trim() === '') return 'Trường này là bắt buộc';
  if (Array.isArray(v) && v.length === 0) return 'Trường này là bắt buộc';
  return null;
}
